import { Box, Button, useTheme } from '@mui/material';
import { loadMoreButtonStyles } from './LoadMoreButton.styles';

export interface LoadMoreButtonProps {
  ariaLabel: string;
  isLoading?: boolean;
  onClick: () => void;
}

export const LoadMoreButton = ({
  ariaLabel,
  isLoading = false,
  onClick,
}: LoadMoreButtonProps) => {
  const theme = useTheme();

  return (
    <Box sx={loadMoreButtonStyles.container(theme)}>
      <Button
        type="button"
        variant="text"
        aria-label={ariaLabel}
        aria-busy={isLoading || undefined}
        disableRipple
        disabled={isLoading}
        onClick={onClick}
        sx={loadMoreButtonStyles.button(theme)}
      >
        Show more...
      </Button>
    </Box>
  );
};

export default LoadMoreButton;
